import { useState } from 'react';
import type { AbilityDemo } from './types';
import { SampleModal } from './SampleModal';

export function AbilityCard({ demo }: { demo: AbilityDemo }) {
  const [showModal, setShowModal] = useState(false);
  const sampleCount = demo.samples?.length ?? 0;

  return (
    <>
      <article id={demo.slug} className="card scroll-mt-28 space-y-3">
        <header className="flex flex-wrap items-baseline justify-between gap-2 border-b border-gold-400/15 pb-2">
          <h3 className="font-serif text-lg text-parchment-50">{demo.label}</h3>
          <div className="font-mono text-[13px] text-gold-300">{demo.roll.formula}</div>
        </header>

        <div className="flex flex-wrap gap-2 text-xs">
          {demo.roll.niche && <span className="chip">{demo.roll.niche}</span>}
          {demo.roll.altPairing && (
            <span className="chip border-gold-400/25 text-parchment-100/75">
              alt: {demo.roll.altPairing}
            </span>
          )}
        </div>

        <p className="text-sm italic text-parchment-100/85 leading-relaxed">
          {demo.vignette}
        </p>

        <div>
          <div className="font-display text-[10px] uppercase tracking-[0.24em] text-gold-400 mb-1">
            When to roll
          </div>
          <ul className="ml-4 list-disc space-y-1 text-sm text-parchment-100/80">
            {demo.whenToUse.map((w, i) => (
              <li key={i}>{w}</li>
            ))}
          </ul>
        </div>

        <div className="flex flex-wrap items-center gap-3 pt-1">
          {sampleCount > 0 && (
            <button
              type="button"
              onClick={() => setShowModal(true)}
              className="font-display text-[11px] uppercase tracking-[0.22em] text-gold-300 hover:text-gold-200 border border-gold-400/30 hover:border-gold-400/60 rounded-sm px-3 py-1.5"
            >
              See {sampleCount} more scenes
            </button>
          )}
          {demo.gotcha && (
            <p className="text-xs muted flex-1">
              <span className="font-display uppercase tracking-[0.22em] text-gold-400 mr-2">
                Gotcha
              </span>
              {demo.gotcha}
            </p>
          )}
        </div>
      </article>

      {showModal && <SampleModal demo={demo} onClose={() => setShowModal(false)} />}
    </>
  );
}
